// extracted by mini-css-extract-plugin
module.exports = {"banner":"UseAppBanner_banner__vGvF2","title":"UseAppBanner_title__h22Gp","message":"UseAppBanner_message__pcs_f","dismiss":"UseAppBanner_dismiss__feGqy"};